import { useRef } from "react";
import { trackHintUsed } from "../lib/metrics";

function storageKey({ sessionCode, stage, playerId }) {
  return `hints_used:${sessionCode}:s${stage}:p${playerId}`;
}

export function useHints({ sessionCode, stage, playerId, metricsPlayerId }) {
  const key = storageKey({ sessionCode, stage, playerId });
  const usedRef = useRef(null);

  if (usedRef.current === null) {
    try {
      const raw = localStorage.getItem(key);
      const arr = raw ? JSON.parse(raw) : [];
      usedRef.current = new Set(Array.isArray(arr) ? arr : []);
    } catch {
      usedRef.current = new Set();
    }
  }

  function persist() {
    try {
      localStorage.setItem(key, JSON.stringify([...usedRef.current]));
    } catch { }
  }

  function markHintUsedOnce({ hintKey, level }) {
    if (!hintKey) return false;

    const k = String(hintKey);
    if (usedRef.current.has(k)) return false;

    usedRef.current.add(k);
    persist();

    trackHintUsed({
      sessionCode,
      stage,
      playerId: metricsPlayerId ?? playerId,
      level,
      hintId: k,
    });

    return true;
  }

  function resetHints() {
    usedRef.current = new Set();
    try {
      localStorage.removeItem(key);
    } catch { }
  }

  return {
    markHintUsedOnce,
    resetHints,
    usedCount: usedRef.current.size,
  };
}